import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { Button } from 'components/form/Button/index';
import Label from 'components/form/Label/Label';
import { useSeenModulePixel } from 'hook/helper.hook';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';

export const QuestionsModule = props => {
  const pixel = useSeenModulePixel({
    'Module Name': 'Sesame Cash Support',
    Vertical: BANKING_VERTICAL,
  });
  return (
    <SectionContainer
      id="QuestionsModule"
      datatestid="QuestionsModule"
      className="duration-4-seg"
    >
      {pixel}
      <Row className="flex-container flex-row m-flex-column align-items-center justify-between">
        <FlexContainer column className="format50 m-format100">
          <Label type="H3" typeHeader={'h3'}>
            Questions?
          </Label>
          <Label type="Body-1" className="margT16">
            We're here to help! Check out our FAQs or contact customer chat.
          </Label>
        </FlexContainer>
        <FlexContainer
          column
          alignItemsStretch
          className="format50 m-format100 margT30"
        >
          <FlexContainer rows justifyEnd alignItemsCenter className="format100">
            <Button
              mrphType="standard"
              className="format38"
              onClick={props.onFAQClick}
            >
              FAQ
            </Button>
            <div className="pad6 m-pad4"></div>
            <Button
              mrphType="standard"
              className="format38"
              onClick={props.onChatClick}
            >
              Chat
            </Button>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
